// Hire Date (DATE_OF_JOINING) filter. The UI-only "type" is BEFORE / BETWEEN / AFTER for dates,
// or MONTH_RANGE for an inclusive month range (1-12) that matches every hire year.
export const MONTH_RANGE = 'MONTH_RANGE';

export const MONTH_OPTIONS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((label, index) => ({ label, value: index + 1 }));

export type DOJFilter = {
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  startMonth?: number | null;
  endMonth?: number | null;
};

export const isMonthRangeDOJ = (doj?: DOJFilter | null) => doj?.type === MONTH_RANGE || doj?.startMonth != null;

export const isDOJFilterApplied = (doj?: DOJFilter | null) =>
  isMonthRangeDOJ(doj) ? doj?.startMonth != null && doj?.endMonth != null : Boolean(doj?.startDate || doj?.endDate);

// API payload without the UI-only "type" key
export const toApiDOJFilter = (doj?: DOJFilter | null) =>
  isMonthRangeDOJ(doj)
    ? { startMonth: doj?.startMonth ?? null, endMonth: doj?.endMonth ?? null }
    : { startDate: doj?.startDate ?? null, endDate: doj?.endDate ?? null };
